import { clientApi } from 'api';
import { IBlogCover } from 'server/models/BlogCover/types';

export const getBlogCover = (isServer = false) => async () => {
  const { data } = await clientApi.get<IBlogCover>('/blog/cover');

  return data;
};
